import { gql } from '../../../../../hooks'

export const READ_PROTOCOLS = gql`
  query AdministrationReadComponentProtocols($id: ID!) {
    aRead(path: "component/protocols", id: $id) {
    }
  }
`

export const UPDATE_PROTOCOLS = gql`
  mutation AdministrationUpdateComponentProtocols($id: ID!, $data: JSONObject) {
    aUpdate(path: "component/protocols", id: $id, data: $data) {
    }
  }
`

export const CREATE_PROTOCOLS = gql`
  mutation AdministrationCreateComponentProtocols($data: JSONObject) {
    aCreate(path: "component/protocols", data: $data) {
    }
  }
`

export const LIST_PROTOCOLS = gql`
  query AdministrationListComponentProtocols(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/protocols"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`

export const SEARCH_CLIENT = gql`
  query AdministrationSearchComponentClient {
    aSearch(path: "client", text: "", filter: { active: 1 }) {
    }
  }
`
